import { DonatePageContent } from '@/types/donate'
import { contributionTiers } from './contributionTiers'
import { taxExemptDonationDisclaimer } from './content'
import heroDonationImage from '@/assets/hero-donation.jpg'

/**
 * Donation page content configuration
 * Content derived from curator text provided by stakeholder
 */
export const donatePageContent: DonatePageContent = {
  hero: {
    title: 'Every Child Deserves Both Parents',
    subtitle:
      'Your donation helps us fight for equal shared parenting legislation that keeps families together and children thriving',
    ctaText: 'Donate Now',
    imageUrl: heroDonationImage,
    imageAlt:
      'Family standing together facing the Capitol building, symbolizing advocacy for equal shared parenting',
  },

  narrative: {
    title: 'Why Your Support Matters',
    paragraphs: [
      'The National Council for Equal Shared Parenting (NCESP) is dedicated to advancing legislative reform, empowering families, and ensuring that children maintain meaningful relationships with both parents. When families are separated, children often lose access to one parent—impacting their emotional well-being, stability, and development.',
      'To expand our national influence and strengthen advocacy efforts, we rely on supporters who believe in this mission. Your contribution directly fuels our ability to host strategic events, build statewide coalitions, educate policymakers, and provide families with tools to drive meaningful change.',
      'Together, we can build a future where equal shared parenting is the standard—not the exception. Your support ensures this movement continues to grow, organize, and influence the policies that shape the lives of families nationwide.',
    ],
    mission:
      'Every dollar strengthens our ability to create lasting, nationwide change for families.',
  },

  fundAllocation: {
    title: 'Where Your Donation Goes',
    intro:
      "Your contribution helps NCESP build a comprehensive nationwide movement for family policy reform. Here's how we invest your support:",
    programs: [
      {
        name: 'Professional Advocacy Events',
        description:
          'Host high-impact events that bring together policymakers, advocates, and families to advance equal shared parenting legislation.',
        icon: 'Event',
      },
      {
        name: 'Legislative Outreach',
        description:
          'Expand our reach across the country, engaging with state legislators and building support for equal parenting policies.',
        icon: 'Gavel',
      },
      {
        name: 'Training & Education Programs',
        description:
          'Develop comprehensive training materials and programs for parents, citizens, and advocates navigating the shared-parenting system.',
        icon: 'School',
      },
      {
        name: 'Strategic Partnerships',
        description:
          'Build partnerships with key policymakers, community leaders, and organizations to amplify our impact.',
        icon: 'Handshake',
      },
      {
        name: 'Family Resources & Support',
        description:
          'Provide critical resources and support to families navigating custody challenges and equal parenting arrangements.',
        icon: 'FamilyRestroom',
      },
    ],
    conclusion:
      'Every contribution makes a meaningful difference in the lives of children and parents across America.',
  },

  tiers: {
    title: 'Ways to Contribute',
    intro:
      'Choose the contribution level that works for you. All supporters help advance our mission, and higher tiers receive special recognition for their commitment.',
    items: contributionTiers,
  },

  disclaimer: {
    text: taxExemptDonationDisclaimer,
    visible: true,
  },

  finalCta: {
    title: 'Make Your Contribution Today',
    description:
      'Join hundreds of supporters building a movement for equal shared parenting. Your donation helps us advocate for policies that keep children connected to both parents.',
    buttonText: 'Donate Now',
  },
}
